import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { GameConstants } from "../../constant/GameConstants";
/**
 * WinLossResponseData.ts
 */
export class WinLossResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyValues();
        }
    }
    solidifyValues() {
        this.totalWin = this.data.getNumber(GameConstants.PROPERTY_TOTAL_WIN);
        this.totalLoss = this.data.getNumber(GameConstants.PROPERTY_TOTAL_LOSS);
    }
    getTotalWin() {
        return this.totalWin;
    }
    getTotalLoss() {
        return this.totalLoss;
    }
}
//# sourceMappingURL=WinLossResponseData.js.map